module.exports = __webpack_public_path__ + "img/3화_4(1).c7e72e2a.jpg";